module.exports = __webpack_public_path__ + "static/img/openEyes.04120886.svg";